<template>
  <div class="page_box">
    <div class="page_table_box" style="height:calc(100% - 10px)">
      <div class="school_table_box">
        <el-table
          :data="tableData"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        >
          <el-table-column type="index" label="序号" width="70" align="center">
          </el-table-column>
          <el-table-column
            prop="title"
            label="标题"
            width="300px"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="props">
              <span>{{ props.row.title || "暂无标题" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="introductionContent"
            label="内容介绍"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="addTime"
            label="添加时间"
            width="200px"
            align="center"
          >
            <template slot-scope="scope">
              {{ $Common.dateFormatDateTwo(scope.row.addTime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150px" align="center">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                plain
                @click="checkInfo(scope.row)"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="searchParams.pageNum"
          :page-size="searchParams.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      :title="loadingTitle"
      :visible.sync="dialogVisible"
      width="50%"
      :modal-append-to-body="false"
      :append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div style="height:400px;overflow:scroll" v-html="loadingInfo"></div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "EpidemicPreventionKnowledge",
  data() {
    return {
      tableData: [],
      searchParams: {
        pageNum: 1,
        pageSize: 20,
        type: 2
      },
      total: 0,
      dialogVisible: false,
      loadingInfo: "",
      loadingTitle: ""
    };
  },
  methods: {
    handleCurrentChange(val) {
      this.searchParams.pageNum = val;
      this.getInfo();
    },
    async getInfo() {
      let res = await this.$Http.getEpidemicPlan(this.searchParams);
      if (res.code == 200) {
        this.tableData = res.data.list || [];
        this.total = res.data.total || 0;
      } else if (res.code == 101) {
        this.tableData = [];
        this.total = 0;
      } else {
        this.tableData = [];
        this.total = 0;
        this.$message({
          type: "error",
          message: res.messsage || "安全知识获取失败"
        });
      }
    },
    checkInfo(row) {
      this.loadingTitle = row.title;
      this.loadingInfo = row.content;
      this.dialogVisible = true;
    }
  },
  created() {},
  mounted() {
    this.getInfo();
  }
};
</script>
